export default "__VITE_ASSET__B7nmnXRS__"